"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITooltipHeader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _H = _interopRequireDefault(require("../elements/headings/H5"));

function UITooltipHeader(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_H.default, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-tooltip__heading', className)
  }));
}

UITooltipHeader.propTypes = {
  children: _propTypes.default.node
};
UITooltipHeader.displayName = 'UITooltipHeader';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/tooltip/UITooltipHeader.js
// module id = 681
// module chunks = 209 210 211 212